import { type User, signOut as firebaseSignOut, onIdTokenChanged } from "firebase/auth";
import { firebaseReady, getFirebaseAuth } from "./firebase";

export async function signOut(): Promise<void> {
  if (!firebaseReady) return;
  await firebaseSignOut(getFirebaseAuth());
}

export function subscribeToAuth(callback: (user: User | null) => void): () => void {
  if (!firebaseReady) {
    callback(null);
    return () => {};
  }
  return onIdTokenChanged(getFirebaseAuth(), callback);
}

export async function getIdToken(forceRefresh = false): Promise<string | null> {
  if (!firebaseReady) return null;
  const user = getFirebaseAuth().currentUser;
  if (!user) return null;
  return user.getIdToken(forceRefresh);
}
